import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=c8520f92&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=c8520f92&prod&lang=scss&"
import style1 from "./contact.vue?vue&type=style&index=1&id=c8520f92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8520f92",
  null
  
)

export default component.exports